<template>
	<MainContent>
		<div class="w-full flex flex-col items-center justify-center">
			<div class="w-full md:w-4/12">
				<div
					v-for="(module, index) in filteredModules"
					:key="index"
					class="select-card with-border mb-3"
					:class="{
						active:
							selected.module && module.id === selected.module.id,
						unavailable: module.is_unavailable,
					}"
					@click="module.is_unavailable ? null : Select(module)"
				>
					<label>
						{{ module.name }}
						<i
							v-if="editable"
							class="fas fa-pen"
							style="margin-right: 2.5rem"
							@click.stop="Edit(module)"
						></i>
						<i class="far fa-chevron-right"></i>
					</label>
				</div>
			</div>
		</div>

		<div
			id="modal-module"
			class="modal fade"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header px-5 py-4">
						<h4 class="font-20 m-0">EDITAR MÓDULO</h4>
						<button
							type="button"
							class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
							data-dismiss="modal"
						>
							<i class="far fa-times mx-1"></i>
						</button>
					</div>
					<hr class="m-0" />
					<div class="modal-body">
						<div class="form-row p-4 justify-content-center">
							<div class="col-12">
								<div class="form-group">
									<input
										type="text"
										placeholder="Nome"
										v-model="form.name"
										class="form-control"
										disabled
									/>
								</div>
							</div>
							<div
								v-if="editable"
								class="col-12"
							>
								<div class="form-group">
									<label>Instruções de Agendamento</label>
									<Editor v-model="form.instructions" />
								</div>
							</div>
						</div>
						<hr class="m-0" />
						<div class="d-flex justify-content-between p-4">
							<button
								class="btn btn-danger p-3 px-4"
								data-dismiss="modal"
							>
								CANCELAR
							</button>

							<button
								class="btn btn-success p-3 px-4"
								@click="Save()"
							>
								SALVAR
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</MainContent>
</template>

<script>
	const _ = require('lodash')
	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	import Editor from './Editor.vue'
	import { useConfirmation, useDeleteAlert, useError } from '@/composables'
	export default {
		name: 'Modules',
		components: {
			Editor,
		},
		props: {
			label: {
				type: String,
				default: '',
			},
			module_id: {
				type: [String, Number],
				default: null,
			},
			type: {
				type: String,
				default: 'strict', //'all'
			},
			filtering_by: {
				type: String,
				default: 'schedule', //'proceeding'
			},
			editable: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selected: {
					module: null,
				},
				form: {
					id: '',
					name: '',
					instructions: '',
				},
			}
		},
		watch: {
			module_id: {
				handler(val) {
					if (val) {
						this.selected.module = this.modules.find(
							m => m.id === parseInt(val)
						)
					}
				},
				immediate: true,
			},
		},
		computed: {
			...mapGetters('system', ['modules']),
			...mapGetters('auth', ['requester_selected_id']),
			filteredModules() {
				return _.sortBy(
					this.modules.filter(module => {
						if (this.type == 'strict') {
							switch (this.filtering_by) {
								case 'schedule':
									return (
										module.have_schedules &&
										module.have_modalities
									)
								case 'proceeding':
									return module.have_modalities
							}
						} else {
							return true
						}
					}),
					'name',
					'asc'
				)
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			Select(module) {
				this.selected.module = module

				this.$emit('next', this.selected.module)
			},
			Edit(module) {
				this.form.id = module.id
				this.form.name = module.name
				this.form.instructions = module.instructions

				window.jQuery('#modal-module').modal('show')
			},
			Save() {
				this.StartLoading()

				return window.api
					.call('post', '/save-modules-and-modalities-instructions', {
						organization_id: this.requester_selected_id,
						type: 'module',
						module_id: this.form.id,
						instructions: this.form.instructions,
					})
					.then(({ data }) => {
						if (data.response) {
							const idx = this.modules.findIndex(
								m => m.id === this.form.id
							)
							if (idx !== -1) {
								this.modules[idx].instructions =
									this.form.instructions
							}

							useConfirmation()
						} else {
							useError(
								'Houve um erro ao concluir, contate o suporte.'
							)
						}
					})
					.finally(() => {
						window.jQuery('.modal').modal('hide')
						this.FinishLoading()
					})
			},
		},
		mounted() {
			if (this.filteredModules.length === 1 && !this.selected.module) {
				this.Select(this.filteredModules[0])
			}

			if (this.filteredModules.length === 0) {
				Swal.fire({
					icon: 'info',
					title: 'Opss...',
					text:
						this.type === 'strict'
							? 'Você não possui agendas cadastradas ou ativas.'
							: 'Não há modulos para exibir.',
					showConfirmButton: true,
					preConfirm: () => {
						this.$router.push({ name: 'Home' })
					},
				})
			}
		},
	}
</script>

<style lang="css" scoped>
	.select-card.unavailable {
		cursor: not-allowed;
	}
	.select-card.unavailable:hover label {
		background-color: firebrick;
		border-color: firebrick !important;
	}

	.select-card.unavailable:hover i {
		color: firebrick !important;
	}

	.modal-dialog {
		max-width: 90%;
	}
</style>
